import { FC } from 'react'
import { StyleSheet, Text, View } from 'react-native'
import { SvgProps } from 'react-native-svg'
import { FontsEnum } from '../../../constants/fonts'
import { isWeb } from '../../../constants/platform'

interface DateTimeProps {
    countdown?: string
    deliveryDate: string
    textColor: string
    SourceIcon?: FC<SvgProps>
    DeliveryIcon: FC<SvgProps>
}

const DateTime: FC<DateTimeProps> = ({
    countdown,
    deliveryDate,
    textColor,
    SourceIcon,
    DeliveryIcon,
}) => {
    return (
        <View style={styles.dateTimeContainer}>
            {countdown && <Text style={[styles.text, { color: textColor }]}>{countdown} |</Text>}
            <View style={styles.iconsContainer}>
                {SourceIcon && <SourceIcon fill={textColor} style={styles.icon} />}
                <DeliveryIcon fill={textColor} style={styles.icon} />
            </View>
            <Text
                numberOfLines={2}
                style={[styles.text, styles.deliveryDateText, { color: textColor }]}
            >
                {deliveryDate}
            </Text>
        </View>
    )
}

const styles = StyleSheet.create({
    dateTimeContainer: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
        marginLeft: 6,
    },
    text: {
        fontFamily: FontsEnum.RUBIK_400_REGULAR,
        fontSize: 16,
    },
    deliveryDateText: {
        flexShrink: 1,
    },
    iconsContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        marginHorizontal: 3,
    },
    icon: isWeb ? { marginLeft: 3, marginRight: 3 } : { marginHorizontal: 3 },
})

export default DateTime
